// src/services/servicioAutenticacion.js (admin)
import api from './api.js';

const CLAVE_TOKEN_ACCESO = 'token_acceso_admin';
const CLAVE_TOKEN_REFRESCO = 'token_refresco_admin';
const CLAVE_TOKEN_ACCESO_LEGADO = 'access_token';
const CLAVE_TOKEN_REFRESCO_LEGADO = 'refresh_token';

function migrarTokensLegado() {
  const tokenLegado = localStorage.getItem(CLAVE_TOKEN_ACCESO_LEGADO);
  const refrescoLegado = localStorage.getItem(CLAVE_TOKEN_REFRESCO_LEGADO);

  const yaMigrado = localStorage.getItem(CLAVE_TOKEN_ACCESO);
  if (!yaMigrado && tokenLegado) {
    localStorage.setItem(CLAVE_TOKEN_ACCESO, tokenLegado);
  }
  if (refrescoLegado && !localStorage.getItem(CLAVE_TOKEN_REFRESCO)) {
    localStorage.setItem(CLAVE_TOKEN_REFRESCO, refrescoLegado);
  }
}

export async function iniciarSesion(correo, clave) {
  const { data } = await api.post('/autenticacion/iniciar', { correo, clave });
  const tokens = data?.data;
  if (!tokens?.access_token) {
    throw new Error('Token de acceso no recibido');
  }
  localStorage.setItem(CLAVE_TOKEN_ACCESO, tokens.access_token);
  if (tokens.refresh_token) {
    localStorage.setItem(CLAVE_TOKEN_REFRESCO, tokens.refresh_token);
  }
  return tokens;
}

export function cerrarSesion() {
  localStorage.removeItem(CLAVE_TOKEN_ACCESO);
  localStorage.removeItem(CLAVE_TOKEN_REFRESCO);
  localStorage.removeItem(CLAVE_TOKEN_ACCESO_LEGADO);
  localStorage.removeItem(CLAVE_TOKEN_REFRESCO_LEGADO);
  window.location.href = '/iniciar-sesion';
}

export async function refrescarSesion() {
  migrarTokensLegado();
  const rt = localStorage.getItem(CLAVE_TOKEN_REFRESCO);
  if (!rt) throw new Error('No hay token de refresco');
  const { data } = await api.post('/autenticacion/refrescar', { refresh_token: rt });
  const access = data?.access_token;
  if (access) localStorage.setItem(CLAVE_TOKEN_ACCESO, access);
  return data;
}

export async function obtenerPerfil() {
  const { data } = await api.get('/autenticacion/perfil');
  return data;
}

function decodificarJwt(token) {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return null;
    const payload = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const json = decodeURIComponent(
      atob(payload)
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(json);
  } catch {
    return null;
  }
}

export function estaAutenticado() {
  migrarTokensLegado();
  const t = localStorage.getItem(CLAVE_TOKEN_ACCESO);
  if (!t) {
    return false;
  }
  const p = decodificarJwt(t);
  if (!p || !p.exp) {
    // Token malformado o sin expiración → tratar como no autenticado
    return false;
  }
  const ahora = Date.now();
  const expMs = p.exp * 1000;
  const valido = expMs > ahora;
  return valido;
}

export function obtenerTokenAcceso() {
  migrarTokensLegado();
  return localStorage.getItem(CLAVE_TOKEN_ACCESO);
}

export default {
  iniciarSesion,
  cerrarSesion,
  refrescarSesion,
  obtenerPerfil,
  estaAutenticado,
  obtenerTokenAcceso
};
